import { ApolloClient, InMemoryCache, HttpLink, from, NormalizedCacheObject, ApolloLink, createHttpLink as createHttpLink1, gql } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'
import { RetryLink } from '@apollo/client/link/retry';
import { setContext as setContext1 } from "@apollo/client/link/context";
import 'bootstrap/dist/css/bootstrap.min.css';
import { onError } from '@apollo/client/link/error';
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, createStore } from "redux";
import CoreRouter from './components/coreRouter/coreRouter';
import thunk from "redux-thunk";
import questionReducer from './store/reducer/questions.reducer';
import { ReactNotifications } from 'react-notifications-component';
import ReactGA from 'react-ga4';
import { IdToken, RedirectLoginOptions, useAuth0 } from "@auth0/auth0-react";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'rsuite/dist/rsuite.min.css'; // or 'rsuite/dist/rsuite.min.css'
import './App.css'; // main style file
import { useEffect, useState } from 'react';
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";
import { getENVData } from './constants/constantValue';
import { IsConnected } from './store/actions';
import Helper from "./Helper";
import * as Sentry from "@sentry/react";
import { readApolloCache, writeApolloCache } from './storage/indexedDb';
// import { persistCache } from 'apollo3-cache-persist';
// import localForage from 'localforage';

// localForage.config({
//   driver: localForage.INDEXEDDB,
//   name: 'dgraph-apollo-cache',
//   storeName: 'graphql_cache'
// });

//const cache = new InMemoryCache();

// const cache = new InMemoryCache({
//   typePolicies: {
//     Query: {
//       fields: {
//         // Example: if your Dgraph query is `getUser(tag: String!)` 
//         // and you want it to look up an entity or connect to existing data
//         queryItinerary: {
//           read(existing, { args, cache: cacheInstance, toReference }) {
//             // 1. Extract the custom search parameter
//             const nameSearch = args?.filter?.key?.allofterms;
//             const matches: any[] = [];

//             if (nameSearch) {
//               // 2. Extract all cached entity keys matching the Typename
//               const allCacheObjects = cacheInstance.extract();
              
//               // 3. Scan the cache keys for User entities
//               for (const key of Object.keys(allCacheObjects)) {
//                 if (key.startsWith('Itinerary:')) {

//                   if (allCacheObjects[key] && allCacheObjects[key].key === nameSearch) {
//                     return [toReference(allCacheObjects[key])];
//                   }
                  
//                   // // 4. Inspect the object properties using a Fragment
//                   // const cachedItinerary = cacheInstance.readFragment({
//                   //   id: key,
//                   //   fragment: gql`
//                   //     fragment FullItineraryCache  on Itinerary {
//                   //       id
//                   //       key
//                   //     }
//                   //   `,
//                   // });

//                   // // 5. If the property matches, return its reference
//                   // if (cachedItinerary && (cachedItinerary as any).key === nameSearch) {
//                   //   //matches.push(cachedItinerary);

//                   //   return [toReference({ __typename: 'User', id: (cachedItinerary as any).id })];
//                   // }
//                 }
//               }
//             }

//             // 6. Return existing cache or undefined to trigger network fetch
//             return matches.length > 0 ? matches : existing;
//           },        
//         },
//       },
//     },
//     // Ensure your Dgraph type uses the proper primary key (Dgraph often uses `id` or `uid`)
//     Itinerary: {
//       keyFields: ['id'], // or ['uid'] depending on your Dgraph schema configuration
//     },
//   },
// });

// async function initApollo(link: ApolloLink) {
//   // 3. Set up the async persistence layer before client setup
//   await persistCache({
//     cache,
//     storage: localForage,
//     maxSize: false, // Set a byte limit or leave false for maximum IndexedDB capacity
//   });

//   // 4. Initialize Apollo Client with the persistent cache
//   const client = new ApolloClient({
//     link,
//     cache,
//   });

//   return client;
// }

const ENV = getENVData()

ReactGA.initialize(ENV.ReactGA);
const rootReducer = combineReducers({
  Question: questionReducer,
});
export type RootState = ReturnType<typeof rootReducer>

const store = createStore(rootReducer, applyMiddleware(thunk));

const createPersistentClient = async (link: ApolloLink, cacheKey: string) => {
  const cache = new InMemoryCache();
  let persistTimer: number | undefined;
  let persistQueue = Promise.resolve();

  try {
    const savedCache = await readApolloCache(cacheKey);
    if (savedCache) cache.restore(savedCache);
  } catch (error) {
    console.warn('Unable to restore the offline itinerary cache:', error);
  }

  const persistenceLink = new ApolloLink((operation, forward) => {
    if (!forward) return null;
    return forward(operation).map((result) => {
      if (persistTimer !== undefined) window.clearTimeout(persistTimer);
      persistTimer = window.setTimeout(() => {
        const snapshot = cache.extract();
        persistQueue = persistQueue
          .then(() => writeApolloCache(cacheKey, snapshot))
          .catch((error) => {
            console.warn('Unable to persist the offline itinerary cache:', error);
          });
      }, 0);
      return result;
    });
  });

  return new ApolloClient({
    cache,
    link: persistenceLink.concat(link),
  });
};

const App = () => {
  const [client, setClient] = useState<ApolloClient>()
  const { isAuthenticated, isLoading, getIdTokenClaims, loginWithRedirect, getAccessTokenSilently } = useAuth0();

  Helper.loginWithRedirect = async (options: RedirectLoginOptions | undefined) => {
    try {
      //if (!Helper.isValidJwt(Helper.token)) {
        const newToken = await getAccessTokenSilently({
          //cacheMode: 'off' // Forces a network call if you want to bypass the memory cache
          detailedResponse: false,
          //* cacheMode: 'no-cache', // Ensure we get a fresh token
          audience: `https://${ENV.Auth0_domain}/api/v2/`
        });

        if (newToken) {
          Helper.token = newToken;

          (window as any).itineraryViewer = {
            token: newToken,
            dgraphQUrl: ENV.GraphQlUrl,
          };
        }
      //}

      return Promise.resolve();
    } 
    catch (error) {
      console.error("Error refreshing token", error);
    }

    if (!options) {
      options = {
        appState: { 
          returnTo: window.location.pathname
        }
      }
    }
    else if (!options.appState) {
      options.appState = { 
        returnTo: window.location.pathname
      }
    }
    else if (!options.appState.returnTo) {
      options.appState.returnTo = window.location.pathname;
    }

    return await loginWithRedirect(options);  
  }
  //Helper.loginWithRedirect = loginWithRedirect;

  // 1. Create a HttpLink
  const httpLink1 = createHttpLink1({
    uri: ENV.GraphQlUrl // Replace with your GraphQL endpoint
  });

  // 2. Create a RetryLink
  const retryLink = new RetryLink({
    delay: (count: number) => {
      return Math.min(count * 1000, 5000); // Delay in milliseconds (exponential backoff)
    },
    attempts: (count: number) => {
      return count <= 1; // Max 1 attempts
    },
  });

  // 3. Create an onError Link
  const onErrorLink = onError(({ networkError, operation, graphQLErrors, forward }) => {
    ;
    if (networkError || graphQLErrors) {
      // Check for 401 (Unauthorized)
      if (networkError && (networkError as any).statusCode === 401) {
        console.log("Retrying after 401 error");
        // Call a function to refresh your login token
        Helper.loginWithRedirect().then(() => {
          // Retry the operation
          return forward(operation);
        });
      }
      else if (graphQLErrors && graphQLErrors.length > 0) {
        // graphQLErrors.forEach(({ message, locations, path }) => {
        //   console.error(
        //     `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        //   );
        // });
        for (let err of graphQLErrors) {
          switch (err.extensions?.code) {
            case "UNAUTHENTICATED":
            case "UNAUTHORIZED":
              Helper.loginWithRedirect().then(() => {
                // Retry the operation;
                return forward(operation);
              });
              break;

            default:
              console.error(`[GraphQL error]: Message: ${err.message}, Location: ${err.locations}, Path: ${err.path}`);
              break;
          }

          if (err.message.includes("token is expired")) {
            Helper.loginWithRedirect().then(() => {
              // Retry the operation;
              return forward(operation);
            });
          }
        }
      }
      else {
        ;
        if (networkError?.message === "This is a test error") {
          console.error(`[Network error]: ${networkError}`);
          Helper.loginWithRedirect().then(() => {
            // Retry the operation;
            return forward(operation);
          });
        }
      }
    }
  });

  // 4. Create the link chain
  const link = ApolloLink.from([retryLink, onErrorLink, httpLink1]);

  const errorLink = onError(({ graphQLErrors }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        console.error(`[GraphQL error]: Message: ${err.message}, Location: ${err.locations}, Path: ${err.path}`);
        // switch (err.extensions?.code) {
        //   case "UNAUTHENTICATED":
        //   case "UNAUTHORIZED":
        //     //Helper.loginWithRedirect();
        //     break;

        //   default:
        //     console.error(`[GraphQL error]: Message: ${err.message}, Location: ${err.locations}, Path: ${err.path}`);
        //     break;
        // }
      }
    }
  });

  // https://github.com/apollographql/apollo-client/issues/4017
  const logLink = new ApolloLink((operation, forward) => {
    console.time(operation.operationName);

    //* throw new Error("This is a test error");

    return forward(operation).map((result: any) => {
      console.timeEnd(operation.operationName);
      console.info('response', operation.getContext());

      return result;
    });
  });

  
  useEffect(() => {
    if (isAuthenticated) {
      getToken();
    } else {
      createPersistentClient(
        retryLink.concat(errorLink.concat(logLink.concat(httpLink1))),
        `apollo:${ENV.GraphQlUrl}:anonymous`
      ).then(setClient).catch((error) => console.error('Unable to create Apollo client:', error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     getToken();
  //   } else {
  //     // setClient(new ApolloClient({
  //     //   cache: new InMemoryCache(),
  //     //   link: retryLink.concat((errorLink).concat(logLink.concat(httpLink1))),
  //     // }));

  //     if (!client) {
  //       const lnk = retryLink.concat((errorLink).concat(logLink.concat(httpLink1)));

  //       initApollo(lnk).then(c => {
  //         setClient(c);
  //       });
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isAuthenticated])

  const origins = ["https://internal.familytc.com", "https://trip.travelsment.com", 'https://trip.familytc.com'];

  useEffect(() => {
    if (!(window as any).originalFetch) {
      (window as any).originalFetch = window.fetch;
      window.fetch = async function (input: RequestInfo | URL, init: RequestInit | undefined) {
        try {
          const response = await (window as any).originalFetch(input, init);

          return response;
        }
        catch(ex: any) {
          const url = typeof input === "string" ? new URL(input) : new URL((input as Request).url);
          const method = init?.method?.toUpperCase() || "GET";

          if (init && init.body && origins.indexOf(url.origin) !== -1 && (method === "POST" || method === "PUT" || method === "PATCH")) {
            try {
            // Store payload as a custom property on the response object
              const sentry_post_body = typeof init.body === "string" 
                ? init.body 
                : JSON.stringify(init.body);

                Sentry.withScope((scope) => {
                  // Attach the post body as extra data or context
                  scope.setExtra("request_body", sentry_post_body);
                  // Alternatively: scope.setContext("request", { body: postBody });
                  
                  //Sentry.captureException(ex);
                  const message = `Fetch error: ${url}, method: ${method}: ${ex.message}`;

                  Sentry.captureMessage(message, {
                    level: "error",
                    tags: {
                        environment: "production",
                        feature: "itinerary-viewer"
                    }
                  });
                });
            } catch (e) {
                // Fail silently if the body cannot be read or stringified
            }
          }

          throw ex;
        }
      };
    }

    Sentry.init({
      dsn: "https://338b3677432d9c62a97dd44db1375c75@o4509413403918336.ingest.us.sentry.io/4511701758246912",
    });

    // Sentry.captureMessage("Itinerary Viewer Loaded", {
    //   level: "info",
    //   tags: {
    //     environment: "production",
    //     feature: "itinerary-viewer"
    //   }
    // });

  }, []);

  const getToken = async () => {
    const data: IdToken | undefined = await getIdTokenClaims();

    const httpLink = createHttpLink({
      uri: ENV.GraphQlUrl
    });
    const authLink = setContext((_, { headers }) => {
      return {
        headers: {
          ...headers,
          "X-Auth-Token": data?.__raw,
        },
      };
    });

    const authLink1 = setContext1((_, { headers }) => {
      return {
        headers: {
          ...headers,
          "X-Auth-Token": data?.__raw,
        },
      };
    });

    // const link = from([
    //   errorLink.concat(authLink.concat(httpLink) as any) as any,
    //   new HttpLink({ uri: ENV.GraphQlUrl })
    // ]);

    // setClient(new ApolloClient({
    //   cache: new InMemoryCache(),
    //   link: retryLink.concat((onErrorLink).concat(authLink1.concat(logLink.concat(httpLink1)))),
    // }));

    // if (!client) {
    //   const lnk = retryLink.concat((onErrorLink).concat(authLink1.concat(logLink.concat(httpLink1))));

    //   initApollo(lnk).then(c => {
    //     setClient(c);
    //   });
    // }

    createPersistentClient(
      retryLink.concat(onErrorLink.concat(authLink1.concat(logLink.concat(httpLink1)))),
      `apollo:${ENV.GraphQlUrl}:${data?.sub || 'authenticated'}`
    ).then(setClient).catch((error) => console.error('Unable to create Apollo client:', error));

    Helper.token = data!.__raw;

    (window as any).itineraryViewer = {
      token: data?.__raw,
      dgraphQUrl: ENV.GraphQlUrl,
    };
  }

  const eventAction = (event: Event) => {
    const customEvent = event as CustomEvent<{ id: string }>;
    store.dispatch(IsConnected(customEvent.detail.id));
  }

  function addTrailingSlashToBrowser(): void {
    // 1. Get the current browser URL as a URL object
    const currentUrl: URL = new URL(window.location.href);
    
    // 2. Check if the pathname already ends with a slash
    if (!currentUrl.pathname.endsWith('/')) {
      currentUrl.pathname += '/';
      
      // 3. Update the address bar without reloading the page
      window.history.replaceState(null, '', currentUrl.toString());
    }
  }

  useEffect(() => {
    const pathname = window.location.pathname;
    const needsIndexHtml = pathname === '/viewer';

    if (needsIndexHtml) {
      // const nextUrl = new URL('/viewer/', window.location.origin).toString();
      // if (window.location.href !== nextUrl) {
      //   window.location.replace(nextUrl);
      // }
      //return;
      addTrailingSlashToBrowser();
    }

    const mycontrol = document.getElementById("root");

    if (mycontrol) {
      mycontrol.addEventListener("itineraryViewer", eventAction as EventListener);

      return () => mycontrol.removeEventListener("itineraryViewer", eventAction);
    }
  }, []);

  return (
    <Provider store={store}>
      <ReactNotifications />
      <div id="pdfPreview"></div>
      <div id="main-content" ></div>
      {!isLoading && client && <ApolloProvider client={client}>
        <CoreRouter />
      </ApolloProvider>}
      <div className='Main'>
        <div className="mainloader">
        </div>
      </div>
    </Provider>
  );
}

export default App;
